import { ChangeDetectionStrategy, Component, EventEmitter, Output, Signal } from '@angular/core';
import { SideContainerInterface, SideContainerTitleInterface, SidenavService } from '../../services';

@Component({
    selector: 'app-sidepanel',
    templateUrl: './sidepanel.component.html',
    styleUrls: ['./sidepanel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SidepanelComponent<T> {
    @Output() close: EventEmitter<void> = new EventEmitter<void>();

    sidenavContent: Signal<SideContainerInterface<T>> = this.sidenavService.content;
    sidenavTitle: Signal<SideContainerTitleInterface | null> = this.sidenavService.title;

    constructor(
        private readonly sidenavService: SidenavService<T>,
    ) {}

    onClose(event?: MouseEvent): void {
        event?.preventDefault();
        this.close.emit();
    }
}
